import React from 'react';
import { Box, Typography } from '@mui/material';

interface InlineMetaDisplayWrapperProps {
    children: React.ReactNode;
}

const InlineMetaDisplayWrapper: React.FC<InlineMetaDisplayWrapperProps> = ({ children }) => {

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                mb: 2,
                width: '100%',
            }}
        >
            <Typography
                variant="caption"
                sx={{
                    // The tokens already flip with the theme; the ternary that
                    // wrapped these picked the SAME value on both branches.
                    bgcolor: 'var(--date-badge-bg)',
                    color: 'var(--date-badge-text)',
                    px: 2,
                    py: 0.5,
                    borderRadius: '8px',
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 1,
                    border: '1px solid var(--date-badge-border)'
                }}
            >
                {children}
            </Typography>
        </Box>
    );
};

export default InlineMetaDisplayWrapper;
